import React from 'react';
type BadgeProps = {
  children: React.ReactNode;
  color?: 'blue' | 'purple' | 'green' | 'gold' | 'red';
};
export const Badge: React.FC<BadgeProps> = ({
  children,
  color = 'blue'
}) => {
  const colorClasses = {
    blue: 'bg-[#19D3DA]/20 text-[#19D3DA]',
    purple: 'bg-[#7D56F4]/20 text-[#7D56F4]',
    green: 'bg-[#4CAF50]/20 text-[#4CAF50]',
    gold: 'bg-[#FFD700]/20 text-[#FFD700]',
    red: 'bg-[#FF5252]/20 text-[#FF5252]'
  };
  return <span className={`inline-flex items-center text-xs font-medium px-2 py-1 rounded-full ${colorClasses[color]}`} data-id="element-890">
      {children}
    </span>;
};